import { Component, OnInit } from '@angular/core';
import {Router}from'@angular/router';
import * as firebase from 'firebase'


@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss']
})
export class DataComponent implements OnInit {
  active = 1;

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  logout() {
    firebase.auth().signOut();
    this.router.navigateByUrl('/home');
  }



  customScript(){
  //   let arrayresults =[]
  //  let q = firebase.firestore().collection("ptws").where("fechafinal","<=","2023-11-01").where("status","==","Aprobado")

  //   q.get().then((res)=>{
  //     console.log("Res size: "+res.size)
  //     res.forEach((item)=>arrayresults.push(item))
  //   })
  //   .then(()=>{
  //     arrayresults.forEach((item,index)=>{
  //       firebase.firestore().collection("ptws").doc(item.id).update({
  //         status:"Cerrado"
  //       })
  //       .then(()=>{
  //         console.log("ejecutado: "+index + " / "+arrayresults.length)
  //       })
  //     })
  //   })
  }

}
